import { apiClient, fastApiClient } from "../App";

// Department Heatmap
export const getDepartmentHeatmap = (departmentId = null) => {
  const query = departmentId ? `?department_id=${departmentId}` : "";
  return fastApiClient.get(`/dashboard/department-heatmap${query}`);
};